import request from '@/utils/request'

/** 门店会员分层统计（口径同 ExportFiles/门店会员分层统计 脚本） */
export function getMemberTierStatistics(data) {
  return request({
    url: '/api/Extend/LqStoreDashboard/GetMemberTierStatistics',
    method: 'post',
    data,
    timeout: 120000
  })
}
